// extracted by mini-css-extract-plugin
export var clickableArea = "videoModalTrigger-module--clickableArea--47a53";
export var video = "videoModalTrigger-module--video--d89a1";
export var videoDuration = "videoModalTrigger-module--videoDuration--e2bd1";
export var videoModalTrigger = "videoModalTrigger-module--videoModalTrigger--88c79";
export var videoOverlayTitle = "videoModalTrigger-module--videoOverlayTitle--b56b7";
export var videoOverlayTitleWrapper = "videoModalTrigger-module--videoOverlayTitleWrapper--c3aff";